/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ContainerData, ContainerModel, TableModel, TextModel } from '@typescript-kit/view';

export interface AccountingDetailComponentData extends ContainerData {
  headerContainer?: ContainerModel;
  allocatedCostsTitle?: TextModel;
  allocatedCostsTable?: TableModel;
  operatingCostsTitle?: TextModel;
  operatingCostsTable?: TableModel;
  resultTitle?: TextModel;
  resultTable?: TableModel;
}

export class AccountingDetailComponentFieldKey {
  static readonly HEADER_CONTAINER = 'headerContainer';
  static readonly ALLOCATED_COSTS_TITLE = 'allocatedCostsTitle';
  static readonly ALLOCATED_COSTS_TABLE = 'allocatedCostsTable';
  static readonly OPERATING_COSTS_TITLE = 'operatingCostsTitle';
  static readonly OPERATING_COSTS_TABLE = 'operatingCostsTable';
  static readonly RESULT_TITLE = 'resultTitle';
  static readonly RESULT_TABLE = 'resultTable';
}

export class AccountingDetailComponentModel extends ContainerModel implements AccountingDetailComponentData {

  get headerContainer(): ContainerModel {
    return this.items.get(AccountingDetailComponentFieldKey.HEADER_CONTAINER) as ContainerModel;
  }

  get allocatedCostsTitle(): TextModel {
    return this.items.get(AccountingDetailComponentFieldKey.ALLOCATED_COSTS_TITLE) as TextModel;
  }

  get allocatedCostsTable(): TableModel {
    return this.items.get(AccountingDetailComponentFieldKey.ALLOCATED_COSTS_TABLE) as TableModel;
  }

  get operatingCostsTitle(): TextModel {
    return this.items.get(AccountingDetailComponentFieldKey.OPERATING_COSTS_TITLE) as TextModel;
  }

  get operatingCostsTable(): TableModel {
    return this.items.get(AccountingDetailComponentFieldKey.OPERATING_COSTS_TABLE) as TableModel;
  }

  get resultTitle(): TextModel {
    return this.items.get(AccountingDetailComponentFieldKey.RESULT_TITLE) as TextModel;
  }

  get resultTable(): TableModel {
    return this.items.get(AccountingDetailComponentFieldKey.RESULT_TABLE) as TableModel;
  }

}
